import React from "react";

export default function TermsScreen() {
  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 20 }}>
      <h1>Terms & Conditions</h1>
      <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>

      <h2>1) Adults only (18+)</h2>
      <p>
        GhanaDating is intended for adults only. By creating an account, you confirm you are at
        least 18 years old. We may suspend or delete accounts we believe are under 18.
      </p>

      <h2>2) Account & safety</h2>
      <ul>
        <li>You must provide accurate information and keep your login secure.</li>
        <li>You are responsible for all activity on your account.</li>
        <li>We may suspend accounts to protect users and the community.</li>
      </ul>

      <h2>3) Community rules</h2>
      <p>
        You agree to follow our Community Guidelines. We do not allow harassment, threats, hate
        speech, scams, impersonation, or sharing illegal content.
      </p>

      <h2>4) No compensated dating / prohibited services</h2>
      <p>
        GhanaDating does not allow content that promotes dating, companionship, or sexual acts in
        exchange for money, gifts, or other compensation. We do not support escorting, prostitution,
        or “sugar” arrangements.
      </p>

      <h2>5) Virtual gifts</h2>
      <p>
        Our in-app virtual gifts are digital items for engagement only. They do not represent an
        obligation to meet in person or provide any service, and they are not a form of payment for
        companionship or dating.
      </p>

      <h2>6) Content & user responsibility</h2>
      <ul>
        <li>You own your content, but you grant us permission to display it in the app/site.</li>
        <li>Do not upload content you don’t have rights to.</li>
        <li>We may remove content that violates our rules or applicable laws.</li>
      </ul>

      <h2>7) Privacy</h2>
      <p>
        Our Privacy Policy explains how we collect and use data. By using GhanaDating, you agree to
        our Privacy Policy.
      </p>

      <h2>8) Changes</h2>
      <p>
        We may update these Terms from time to time. Continued use means you accept the updated
        Terms.
      </p>

      <h2>9) Contact</h2>
      <p>
        For support, contact us through the in-app/report tools or your support email/contact page
        if available.
      </p>
    </main>
  );
}